import type { Dispatch } from 'redux'
import { Cart, nativeAppHeaders } from '@ynap/api-utils'
import { delay } from '@ynap/promise-utils'
import { getLocale } from '@ynap/cart-state'
import { getWatsonConfig, getTimeout, getDelay } from '@ynap/cart-state/src/selectors/getConfig'
import { StoreState } from 'app/state/types'
import wrapFetchWithJSON from './common/wrapFetchWithJSON'
import { setPaymentMethodRequest, setPaymentMethodSuccess, setPaymentMethodError } from './setPaymentMethod'
import { getAdditionalCheckoutHeaders } from '../utils/checkoutActionUtils'
import { checkRectificationOnError, checkRectificationOnSuccess } from '../actions/cartRectification'
import { checkoutError } from './checkout'
import { checkGuestIdentityError } from './checkGuestIdentityError'

export default function setPaymentAddress(values: { addressId: number }) {
    return async (dispatch: Dispatch, getState: () => StoreState, fetch: WindowOrWorkerGlobalScope['fetch']) => {
        const state = getState()

        const fetchJSON = wrapFetchWithJSON(fetch, getTimeout(state))

        const watsonConfig = getWatsonConfig(state)
        const { langId } = getLocale(state)
        const additionalHeaders = {
            ...nativeAppHeaders(state.deviceType),
            ...getAdditionalCheckoutHeaders(state),
        }

        dispatch(setPaymentMethodRequest())

        try {
            const request = Cart.setPaymentInstruction({
                paymentInstruction: [
                    {
                        billing_address_id: values.addressId,
                    },
                ],
                ...watsonConfig,
                langId,
                additionalHeaders,
                clearExisting: 'false',
            })

            const data = await delay(fetchJSON(request), getDelay(state))
            dispatch(setPaymentMethodSuccess(data))
            checkRectificationOnSuccess(dispatch, data)
            return data
        } catch (error: any) {
            if (error.response) {
                try {
                    const json = await error.response.clone().json()
                    const jsonError = json.errors[0] && json.errors[0]
                    if (jsonError) {
                        dispatch(checkoutError(jsonError))
                    }
                } catch (e) {
                    dispatch(setPaymentMethodError(error))
                }
            }
            checkRectificationOnError(error, dispatch)
            checkGuestIdentityError(error, dispatch, state)
            dispatch(setPaymentMethodError(error))
        }
    }
}
